import React from "react";
// @material-ui/core components
import {makeStyles, withStyles} from "@material-ui/core/styles";
// @material-ui/icons
import TrendingUp from "@material-ui/icons/TrendingUp";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Info from "components/Typography/Info.js";
import Danger from "components/Typography/Danger.js";
import Success from "components/Typography/Success.js";
import Button from "components/CustomButtons/Button.js";

import blogPostPageStyle from "assets/jss/material-kit-pro-react/views/blogPostPageStyle.js";


import BaseHeader from "./BaseView/BaseHeader";
import Parallax from "../components/Parallax/Parallax";
import BaseFooter from "./BaseView/BaseFooter";
import SeriesItem from "./components/SeriesItem";
import {getAllSeries} from "../utils/request";
import intl from "react-intl-universal";

class Series extends React.Component {


	constructor(props) {
		super(props);
		this.state = {
			seriesListData: [],
		};
		document.title = intl.get('series') + " - RobinAlgo";
		this.initData();
	}


	initData = () => {
		getAllSeries().then(res => {
			this.setState({
				seriesListData: res.data
			})
		})
	}


	render() {
		const {classes} = this.props;


		const tags = this.state.seriesListData.map(data => {
			return <SeriesItem
				// callback={this.callback.bind(this)}
				data={data}
			/>
		});

		return (
			<div>
				<BaseHeader fixed/>

				<Parallax image={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/series_bg.jpg"}
						  filter="dark" small>
					<div className={classes.container}>
						<GridContainer justify="center">
							<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
								<h1 className={classes.title} style={{color: "white"}}>
									{intl.get('title_series')}
								</h1>
							</GridItem>
							<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
								<h4 className={classes.title} style={{color: "white"}}>
									{intl.get('series_show_info')}
								</h4>
							</GridItem>
						</GridContainer>
					</div>
				</Parallax>
				<div className={classes.main} >
					<div className={classes.container}>
						<GridContainer>
							<GridItem
								xs={12}
								sm={10}
								md={10}
								className={classes.mlAuto + " " + classes.mrAuto}
							>

								{tags}
							</GridItem>
						</GridContainer>
					</div>
				</div>

				<BaseFooter/>

			</div>

		);
	}
}

export default withStyles(blogPostPageStyle)(Series)
